// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__I8_W0","amount":"Amount_amount__2qV-7","tip":"Amount_tip__1Y9yf","tipHeader":"Amount_tipHeader__22Vw7","tipsWrap":"Amount_tipsWrap__-jjpj"};